import connectApi from 'api/connectApi'
import { constants } from './constants'
import { ClientType } from 'storeTypes'

export const PHONE_LOOKUP_TIMEOUT_MS = 15000

export type PhoneLookupMatch = ClientType & { is_default?: boolean }

export type PhoneLookupResult =
    | { status: 'match'; clients: PhoneLookupMatch[] }
    | { status: 'no_match' }
    | { status: 'incomplete' }
    | { status: 'offline' }

type LookupResponse = {
    status?: number
    data?: {
        clients?: PhoneLookupMatch[]
        incomplete?: boolean
    }
}

export const lookupPrimaryPhone = async ({
    number,
    excludeClientCode,
    isOnline
}: {
    number: string
    excludeClientCode?: string
    isOnline: boolean
}): Promise<PhoneLookupResult> => {
    if (!isOnline) return { status: 'offline' }
    try {
        const response = (await connectApi.get(
            constants.endpoints.PHONE_LOOKUP,
            {
                params: {
                    number,
                    ...(excludeClientCode
                        ? { exclude_client_code: excludeClientCode }
                        : {})
                },
                timeout: PHONE_LOOKUP_TIMEOUT_MS
            }
        )) as LookupResponse
        if (response?.status !== 200) return { status: 'offline' }
        if (response.data?.incomplete) return { status: 'incomplete' }
        const clients = response.data?.clients || []
        if (!clients.length) return { status: 'no_match' }
        return { status: 'match', clients }
    } catch {
        return { status: 'offline' }
    }
}
